<template>
<div class="mt-3" v-if="rows.length > 0">
    <div class="flex justify-between items-center bg-indigo-600 rounded-lg py-2 px-3">
        <h2 class="text-white text-sm font-semibold">Loyers du mois</h2>
    </div>
    <div class="px-2 py-3 overflow-x-auto">
        <table class="w-full text-sm">
            <thead>
                <tr class="text-xs text-gray-500 dark:text-gray-400">
                    <th class="text-left font-normal pb-2">Propriétaire</th>
                    <th class="text-right font-normal pb-2">Perçus</th>
                    <th class="text-right font-normal pb-2">À percevoir</th>
                    <th class="text-right font-normal pb-2">%</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in rows" :key="row.key" class="border-b border-gray-100 dark:border-gray-800 last:border-0">
                    <td class="py-1.5 text-gray-600 dark:text-gray-300">{{ row.titre }}</td>
                    <td class="py-1.5 text-right font-medium text-slate-800 dark:text-gray-100">{{ format(row.montantPaye) }}</td>
                    <td class="py-1.5 text-right font-medium text-slate-800 dark:text-gray-100">{{ format(row.montantAPercevoir) }}</td>
                    <td class="py-1.5 text-right text-xs text-gray-500">{{ row.percent.toFixed(0) }} %</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
</template>

<script>
import { computed } from 'vue';

export default {
    props: {
        cards: {
            type: Array,
            default: () => []
        }
    },

    setup(props) {
        const rows = computed(() => props.cards
            .map(card => {
                const montantPaye = card.statistiques.loyers_payes;
                const montantAPercevoir = card.statistiques.loyers_a_percevoir;
                const total = montantPaye + montantAPercevoir;

                return {
                    key: card.key,
                    titre: card.titre,
                    montantPaye,
                    montantAPercevoir,
                    percent: total > 0 ? Math.min(100 * montantPaye / total, 100) : 0
                };
            })
            .filter(row => (row.montantPaye + row.montantAPercevoir) > 0)
        );

        function format(value) {
            return `${Number(value || 0).toLocaleString('fr-FR', {minimumFractionDigits: 2, maximumFractionDigits: 2})} €`;
        }

        return { rows, format };
    }
};
</script>
